"use client";

import { ArcElement, Chart as ChartJS } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement);

const options = {
  animation: false,
  overrides: {
    doughnut: {
      plugins: {
        legend: {
          display: false,
        },
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
  },
};

const getData = ({ isNoData }: { isNoData: boolean }) => ({
  labels: ["1", "2", "3", "4", "5"],
  datasets: [
    {
      label: "# score",
      data: [1, 1, 1, 1, 1],
      offset: 20,
      backgroundColor: isNoData
        ? ["#E4E4E7", "#E4E4E7", "#E4E4E7", "#E4E4E7", "#E4E4E7"]
        : ["#EF4444", "#FCA5A5", "#E4E4E7", "#9EF2BD", "#22C55E"],
      borderWidth: 1,
      circumference: 180,
      rotation: 270,
      cutout: "65%",
    },
  ],
});

export const GaugeChart = ({ isNoData }: { isNoData: boolean }) => (
  <Doughnut data={getData({ isNoData })} options={options} />
);
